import { render, staticRenderFns } from "./OpenBillingSerieForm.vue?vue&type=template&id=5dc163a3&scoped=true&"
import script from "./OpenBillingSerieForm.vue?vue&type=script&lang=js&"
export * from "./OpenBillingSerieForm.vue?vue&type=script&lang=js&"
import style0 from "./OpenBillingSerieForm.vue?vue&type=style&index=0&id=5dc163a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc163a3",
  null
  
)

export default component.exports